import React from "react";
import _ from "lodash";
import Select from "react-select";

class FloorPriceModeControl extends React.PureComponent {
  constructor(props) {
    super(props);

    const { inputValue, relatedValue } = props;

    this.state = {
      floorPriceMode: inputValue,
      selectedBidder: relatedValue[0] || [],
    };

    this.handleFloorPriceModeChanged =
      this.handleFloorPriceModeChanged.bind(this);
    this.handleUpdateParentData = this.handleUpdateParentData.bind(this);
  }

  componentDidMount() {
    this.handleUpdateParentData();
  }

  handleFloorPriceModeChanged({ floorPriceMode, selectedBidder }) {
    this.setState({ floorPriceMode, selectedBidder }, () => {
      this.handleUpdateParentData();
    });
  }

  handleUpdateParentData() {
    const {
      handleNewValueChanged,
      handleRelatedNewValueChanged,
      handleRelatedUseDefaultChanged,
    } = this.props;

    const { floorPriceMode, selectedBidder } = this.state;

    if (handleNewValueChanged) {
      handleNewValueChanged(floorPriceMode);
    }

    if (handleRelatedUseDefaultChanged) {
      if (_.isNil(selectedBidder)) {
        handleRelatedUseDefaultChanged(0, true);
      } else {
        handleRelatedUseDefaultChanged(0, false);
      }
    }

    if (handleRelatedNewValueChanged && !_.isNil(selectedBidder)) {
      handleRelatedNewValueChanged(0, selectedBidder);
    }
  }

  render() {
    const { valueSchema, relatedSchema } = this.props;

    const { floorPriceMode, selectedBidder } = this.state;

    const options = _.map(valueSchema.enum, (key) => {
      return { value: key, label: key };
    });
    const selectedOption = _.find(options, { value: floorPriceMode });

    const bidderOptions = _.map(
      _.get(relatedSchema, [0, "enum"], {}),
      (key) => {
        return { value: key, label: key };
      },
    );
    const selectedBidderOptions = _.filter(bidderOptions, (option) => {
      return _.includes(selectedBidder, option.value);
    });

    return (
      <div className="w-full">
        <Select
          className="w-1/2"
          isMulti={false}
          closeMenuOnSelect={true}
          options={options}
          value={selectedOption}
          onChange={({ value }) =>
            this.handleFloorPriceModeChanged({
              floorPriceMode: value,
              selectedBidder: value === "SELECTED_BIDDER" ? [] : undefined,
            })
          }
        />
        {floorPriceMode === "SELECTED_BIDDER" && (
          <div className="mt-2">
            <label>
              Selected Bidders{" "}
              <span className="text-xs text-gray-600">
                An empty list indicates that all bidders are selected.
              </span>
            </label>
            <Select
              placeholder="All bidders"
              options={bidderOptions}
              value={selectedBidderOptions}
              onChange={(list) =>
                this.handleFloorPriceModeChanged({
                  floorPriceMode,
                  selectedBidder: (list || []).map((option) => option.value),
                })
              }
              isMulti={true}
              closeMenuOnSelect={false}
            />
          </div>
        )}
      </div>
    );
  }
}

export default FloorPriceModeControl;
